/*
  LASE — Part PDP variant switching (sections/lase-part-hero.liquid).

  The stage shows the selected variant's DAY and NIGHT photo side by
  side; the buy card has Size buttons + Colour swatches. On any picker
  change we resolve the matching variant from the embedded JSON and
  update: both images, price, hidden form id, active states and the
  ?variant= URL param. Add to cart stays a native form post.
*/
(function () {
  'use strict';

  function setup (root) {
    if (root.dataset.lasePartBound) return;
    root.dataset.lasePartBound = '1';

    const dataTag = root.querySelector('[data-part-variants]');
    if (!dataTag) return;
    let variants = [];
    try { variants = JSON.parse(dataTag.textContent); } catch (e) { return; }
    const colorIdx = parseInt(dataTag.dataset.colorIdx, 10);
    const sizeIdx  = parseInt(dataTag.dataset.sizeIdx, 10);

    const dayImg   = root.querySelector('[data-part-day]');
    const nightImg = root.querySelector('[data-part-night]');
    const priceEl  = root.querySelector('[data-part-price]');
    const idInput  = root.querySelector('[data-part-variant-id]');
    const cta      = root.querySelector('[data-part-cta]');
    const curSize  = root.querySelector('[data-part-current-size]');
    const curColor = root.querySelector('[data-part-current-color]');

    // Selected option values — start from the variant the server rendered.
    const initial = variants.find(v => String(v.id) === String(idInput?.value)) || variants[0];
    if (!initial) return;
    let selSize  = sizeIdx  >= 0 ? initial.options[sizeIdx]  : null;
    let selColor = colorIdx >= 0 ? initial.options[colorIdx] : null;

    function resolve () {
      return variants.find(v =>
        (selSize  == null || v.options[sizeIdx]  === selSize) &&
        (selColor == null || v.options[colorIdx] === selColor)
      );
    }

    function apply () {
      const v = resolve();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (dayImg && v.day)     dayImg.src   = v.day;
      if (nightImg && v.night) nightImg.src = v.night;
      if (curSize)  curSize.textContent  = selSize  || '';
      if (curColor) curColor.textContent = selColor || '';
      if (cta) cta.disabled = !v.available;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } catch (e) { /* non-critical */ }
    }

    root.querySelectorAll('[data-part-size]').forEach(btn => {
      btn.addEventListener('click', () => {
        selSize = btn.dataset.partSize;
        root.querySelectorAll('[data-part-size]').forEach(b =>
          b.classList.toggle('is-active', b === btn));
        apply();
      });
    });

    root.querySelectorAll('[data-part-swatch] input').forEach(input => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        selColor = input.value;
        apply();
      });
    });

    // ---- Stage interactions: click swaps day|night, arrow follower ----
    const gallery = root.querySelector('[data-part-gallery]');
    const duo     = root.querySelector('[data-part-duo]');
    if (gallery && duo && nightImg) {
      gallery.addEventListener('click', () => {
        duo.classList.toggle('is-swapped');
        duo.classList.remove('is-anim');
        void duo.offsetWidth;          // restart the crossfade
        duo.classList.add('is-anim');
      });
    }
    const cursor      = root.querySelector('[data-part-cursor]');
    const cursorArrow = root.querySelector('[data-part-cursor-arrow]');
    const finePointer = window.matchMedia('(pointer: fine)').matches;
    if (gallery && cursor && finePointer && nightImg) {
      gallery.addEventListener('mousemove', (e) => {
        cursor.style.transform = 'translate3d(' + e.clientX + 'px, ' + e.clientY + 'px, 0)';
        cursor.classList.add('is-visible');
        const rect = gallery.getBoundingClientRect();
        const isLeft = (e.clientX - rect.left) < rect.width / 2;
        if (cursorArrow) cursorArrow.textContent = isLeft ? '←' : '→';
      });
      gallery.addEventListener('mouseleave', () => cursor.classList.remove('is-visible'));
    }
  }

  function init () {
    document.querySelectorAll('[data-part-pdp]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
